<template>
  <div class="vb-services">
    <flights v-if="has_flights" :flights="services.flights"></flights>
    <hotels
      :class="has_flights ? 'mt-4' : ''"
      :hotels="services.hotels"
      :supplements="services.travelSupplements"
    ></hotels>
  </div>
</template>

<script>
import Flights from "@alpitour/components/blocks/flights.vue";
import Hotels from "@alpitour/components/blocks/hotels.vue";
export default {
  name: "services",
  props: {
    services: Object,
  },
  components: {
    flights: Flights,
    hotels: Hotels,
  },
  computed: {
    has_flights() {
      const { flights = [] } = this.services || {};
      return flights.length > 0;
    },
  },
};
</script>

<style lang="scss">
.vb-services {
  background-color: #fff;
  border-radius: $border-radius-lg;
  padding: 1.25rem;

  &:not(.vb-quote &) {
    margin-bottom: $grid-gutter-width;
  }
}
</style>
